import '../styles/MediaCard.scss';

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase-config';

import WatchPopup from './WatchPopup';
import { useHistory } from '../hooks/HistoryContext';

const MediaCard = ({ media, showDetails = false }: { media: any, showDetails: boolean }) => {
    const { history } = useHistory();
    const [watched, setWatched] = React.useState(false);
    const title = media.title || media.name || '';
    const releaseDate = media.release_date || media.first_air_date || '';

    useEffect(() => {
        setWatched(history.some(item => item.tmdb_id.toString() === media.id.toString()));
    }, [history, media.id]);

    const PosterImage = () => {
        if (!media.poster_path) {
            return (
                <div className="media-poster placeholder" title={title}>
                    <img src="/assets/image-placeholder.svg" alt="None Available" className="image-placeholder" draggable={false} />
                </div>
            );
        }

        return (
            <img
                src={`https://image.tmdb.org/t/p/w500${media.poster_path}`}
                alt={title}
                title={title}
                className="media-poster"
                loading="lazy"
                draggable={false}
            />
        )
    }

    return (
        <div className="media-card" id={media.id}>
            <Link className='media-link' to={`/${media.media_type}/${media.id}`}>
                <PosterImage />
                <div className='media-info'>
                    <div className='media-title' title={title}>{title}</div>
                    {showDetails && releaseDate && (
                        <div className='media-release-date' title={new Date(releaseDate).toLocaleDateString()}>
                            {new Date(releaseDate).getFullYear()}
                        </div>
                    )}
                    {showDetails && media.character && (
                        <div className='character-name' title={media.character}>{media.character}</div>
                    )}
                </div>
            </Link>

            {auth.currentUser && (
                <div className="movie-actions">
                    <svg
                        className={`check-mark-box ${watched ? 'selected' : ''}`}
                        id={`check-mark-box-${media.id}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 48 48"
                    >
                        <path id="check-mark" d="M36,42H12c-3.314,0-6-2.686-6-6V12c0-3.314,2.686-6,6-6h24c3.314,0,6,2.686,6,6v24C42,39.314,39.314,42,36,42z"/>
                        <path id="check-box" d="M34.585 14.586L21.014 28.172 15.413 22.584 12.587 25.416 21.019 33.828 37.415 17.414z"/>
                    </svg>
                    <WatchPopup anchorSelect={`#check-mark-box-${media.id}`} media={media} onWatched={() => setWatched(true)} />
                </div>
            )}
        </div>
    );
};

export default MediaCard;
